<template lang="pug">
    div
        v-simple-table
            template(v-slot:default)
                thead
                    tr
                        th
                            v-btn(
                                small
                                color='var(--volie-blue)'
                                outlined
                                :loading="loadingUpload"
                                :disabled="loadingTicketUpdate"
                                @click="openAttachmentInput()"
                            )
                                v-icon(small) mdi-plus
                                | {{ assets.length > 0 ? "Add more attachments" : "Add attachments" }}
                            v-file-input(
                                id="asset-attachment-input"
                                accept="audio/*,video/*,image/*,.csv,.doc,.docx,.pdf,.txt,.rtf,.html,.xls,.xlsx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.zip,.mkv,.ppt,.pptx"
                                multiple
                                style="display: none;"
                                v-model="newAttachmentFiles"
                                @change="onAttachmentInputChange();"
                            )
                tbody
                    tr(v-for="(asset, idx) in assets" :key="idx")
                        td
                            v-card-text.row(v-if="asset.file_type === 'image'")
                                v-img(
                                    contain
                                    max-height='250'
                                    max-width='250'
                                    :src='asset.asset_url'
                                )
                                v-btn(small color='error' style='margin: 0 12px;' :disabled="loadingTicketUpdate" @click='onDeleteAssets(idx);')
                                    v-icon mdi-delete
                            a(v-else :href="asset.asset_url") {{ asset.original_file_name }}
    
        MediaSelector(
            :on-paste="onImagePaste"
            :only-selectable="true"
            :show-snackbar="showSnackbar"
        )

</template>

<script lang="ts">
    import Vue from 'vue';
    import $ from 'jquery';

    // Data
    import { CreateAssets } from "@/data";

    // Components
    import MediaSelector from '@/components/shared/media_selector.vue';

    export default Vue.extend({
        data() {
            return {
                assets: [],
                fileUrls: [],
                loadingUpload: false,
                newAttachmentFiles: null,
            }
        },
        methods: {
            openAttachmentInput() {
                $("#asset-attachment-input")?.click();
            },
            onAttachmentInputChange() {

                // Verify valid files
                if (!(this.newAttachmentFiles?.length > 0) && !(this.fileUrls?.length > 0)) {
                    return;
                }

                // Init formData
                const formData = new FormData();

                // Set common fields
                formData.set("account_id", (this.accountId || 0));
                formData.set("asset_id", (this.ticketId || 0));
                formData.set("asset_type", "ticket");

                // Loop over files and append to formData
                for (let i = 0; i < this.newAttachmentFiles?.length; i++) {
                    // Append
                    // Key is 'file-1', 'file-2', etc
                    formData.append("file-" + (i + 1), this.newAttachmentFiles[i]);
                }

                for (let i = 0; i < this.fileUrls?.length; i++) {
                    formData.append("file-url-" + (i + 1), this.fileUrls[i]);
                }

                if (this.ticketId) {
                    this.createAssets(formData);
                } else {
                    this.$emit("create-assets-form-data", formData);
                }
            },
            createAssets(formData) {

                if (!formData) {
                    return;
                }

                this.loadingUpload = true;
                CreateAssets(formData).then((response) => {

                    this.loadingUpload = false;

                    // Empty new attachment files
                    this.newAttachmentFiles = [];
                    this.fileUrls = [];

                    if (response.Data?.assets?.length > 0) {
                        
                        for(let i = 0; i < response.Data.assets.length; i++) {

                            // Init
                            const asset = response.Data.assets[i];
                            if (!(asset?.asset_url?.length > 0)) {
                                continue;
                            }

                            // Append
                            let find = false;
                            this.assets.forEach(function (src) {
                                if (src?.asset_url == asset.asset_url) {
                                    find = true;
                                }
                            });
                            if (!find) {
                                this.assets.push(asset);
                            }
                        }
                    } else {
                        this.showSnackbar("error", "Unable to create new asset");
                    }

                    if (this.assets?.length > 0 && this.updatedAssets) {
                        this.updatedAssets(this.assets);
                    }

                });
            },
            onDeleteAssets(idx) {
                this.assets.splice(idx, 1);
                if (this.updatedAssets) {
                    this.updatedAssets(this.assets);
                }
            },
            onImagePaste(imageUrl) {
                if (this.loadingUpload) {
                    return;
                }

                this.fileUrls.push(imageUrl);
                this.onAttachmentInputChange();
            },
        },
        computed: {},
        components: {
            MediaSelector,
        },
        props: {
            accountId:              Number,
            loadingTicketUpdate:    Boolean,
            showSnackbar:           Function,
            ticketId:               Number,
            updatedAssets:          Function,
        },
        created() {
            return;
        },
    });
</script>

<style lang="scss" scoped>
</style>